/*
 * File: AttentionInput.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 May 2021 2:15:33 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Input, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { useField } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { useLocation } from 'react-router-dom';
const { Title } = Typography;
const { TextArea } = Input;

const styles: InlineStylesModel = {
  formItem: {
    marginBottom: 10
  },
  titleColor: {
    color: '#2F5596'
  }
};

export const AttentionInput = (): JSX.Element => {
  const [{ value }, _, { setValue }] = useField<string>('attention');
  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');

  /* ****************** Functions ****************** */
  const onInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setValue(e.target.value);
  };

  /* ****************** Render ****************** */
  return (
    <>
      <Title level={5} style={styles.titleColor}>
        {CreateSalesOrderType.ATTENTION}
      </Title>
      <TextArea disabled={isPosted} name="attention" value={value} allowClear onChange={onInputChange} />
    </>
  );
};
